<template>
  <div class="player margin-between-section">
    <div class="row not-margin">
      <div class="col-md-12 container-info">
        <h1>{{ $t('admin.upload_player')}}</h1>
        <router-link to="/admin">
          <img src="../assets/images/back.png" /> {{ $t('admin.back')}}
        </router-link>
      </div>
    </div>
    <div class="row not-margin">
      <div class="col-md-6 info-form-contact margin-between-section">
        <div class="group">
          <input v-model="nombre" class="input-form" type="text" :placeholder=" $t('admin.name')" />
        </div>
        <div class="group">
          <input v-model="apellido" class="input-form" type="text" :placeholder=" $t('admin.last_name')" />
        </div>
        <div class="group">
          <input v-model="liga" class="input-form" type="text" :placeholder=" $t('admin.league')" />
        </div>
        <div class="group">
          <input v-model="equipo" class="input-form" type="text" :placeholder=" $t('admin.team')" />
        </div>
        <div class="group">
          <input v-model="fecha" class="input-form" type="text" onfocus="(this.type='date')" :placeholder=" $t('admin.birthday')" />
        </div>
        <div class="group">
          <input v-model="altura" @keypress="isNumber($event)" class="input-form" type="text" :placeholder=" $t('admin.height')" maxlength="3" />
        </div>
        <div class="group">
          <input v-model="contacto" class="input-form" type="email" :placeholder=" $t('admin.contact')"/>
        </div>
        <div class="group">
          <input v-model="skillGral" class="input-form" type="text" :placeholder=" $t('admin.skill_gral')"/>
        </div>
        <div class="dropdown" style="margin-top: 5%">
          <template class="btn-d">
            <select v-model="cost" class="browser-default custom-select btn-d">
              <option selected value="">{{ $t('admin.cost')}}</option>
              <option v-for="item in costList" :key="item.id" :value=item.value >{{item.position}}</option>
            </select>
          </template>
        </div>
        <div class="group"><p class="error" v-if="error != ''" >* {{error}}</p></div>
      </div>
      <div class="col-md-6 info-form-contact margin-between-section">
        <div class="container-drop">
          <div class="dropdown f-l">
            <template class="btn-d">
              <select v-if="$t('flag.flag') == 'es'" v-model="nacionalidad" class="browser-default custom-select btn-d">
                <option selected value="">{{ $t('playerFilter.nacionality')}}</option>
                <option v-for="item in countries" :key="'a'+item.id" :value=item.pais >{{item.pais}}</option>
              </select>
              <select v-else v-model="nacionalidad" class="browser-default custom-select btn-d">
                <option selected value="">{{ $t('playerFilter.nacionality')}}</option>
                <option v-for="item in countries" :key="'b'+item.id" :value=item.pais_eng >{{item.pais_eng}}</option>
              </select>

            </template>
          </div>
          <div class="dropdown">
            <template class="btn-d">
              <select v-if="$t('flag.flag') == 'es'" v-model="pasaporte" class="browser-default custom-select btn-d">
                <option selected value="">{{ $t('playerFilter.passport')}}</option>
                <option v-for="item in countries" :key="item.id" :value=item.gentilicio >{{item.gentilicio}}</option>
              </select>
              <select v-else v-model="pasaporte" class="browser-default custom-select btn-d">
                <option selected value="">{{ $t('playerFilter.passport')}}</option>
                <option v-for="item in countries" :key="item.id" :value=item.gentilicio_eng >{{item.gentilicio_eng}}</option>
              </select>
            </template>
          </div>
          <div class="dropdown f-r">
            <template class="btn-d">
              <select v-model="pierna" class="browser-default custom-select btn-d">
                <option selected value="">{{ $t('playerFilter.foot')}}</option>
                <option :value="$t('playerFilter.footRight')">{{ $t('playerFilter.footRight')}}</option>
                <option :value="$t('playerFilter.footLeft')">{{ $t('playerFilter.footLeft')}}</option>
                <option :value="$t('playerFilter.footBoth')">{{ $t('playerFilter.footBoth')}}</option>
              </select>
            </template>
          </div>
        </div>
        <div class="c-footer margin-between-section">
          <div class="container-age">
            <p class="instruction">{{ $t('admin.select_postions')}}</p>
            <div class="content-button-filter">
              <div class="def camp-position margin-between-section">
                <p class="instruction-position">{{ $t('playerFilter.defense')}}:</p>
                <ul v-if="$t('flag.flag') == 'es'">
                  <li v-for="item in jsonDefEsp" :key="item.id">
                    <button @mouseover="position(item.value)" v-on:click="positionSelected(item.position, item.position, item.value)" :class="{'active-btn-gray': isClicked[item.position]}" class="btn btn-position">{{ item.positionEsp }}</button>
                  </li>
                </ul>
                <ul v-else>
                  <li v-for="item in jsonDef" :key="item.id">
                    <button @mouseover="position(item.value)" v-on:click="positionSelected(item.position, item.position, item.value)" :class="{'active-btn-gray': isClicked[item.position]}" class="btn btn-position">{{ item.position }}</button>
                  </li>
                </ul>
              </div>
              <div class="def camp-position">
                <p class="instruction-position">{{ $t('playerFilter.midfield')}}:</p>
                <ul v-if="$t('flag.flag') == 'es'">
                  <li v-for="item in jsonMedEsp" :key="item.id">
                    <button @mouseover="position(item.value)" v-on:click="positionSelected(item.position, item.position, item.value)" :class="{'active-btn-gray': isClicked[item.position]}" class="btn btn-position">{{ item.positionEsp }}</button>
                  </li>
                </ul>
                <ul v-else>
                  <li v-for="item in jsonMed" :key="item.id">
                    <button @mouseover="position(item.value)" v-on:click="positionSelected(item.position, item.position, item.value)" :class="{'active-btn-gray': isClicked[item.position]}" class="btn btn-position">{{ item.position }}</button>
                  </li>
                </ul>
              </div>
              <div class="def camp-position">
                <p class="instruction-position">{{ $t('playerFilter.forward')}}:</p>
                <ul v-if="$t('flag.flag') == 'es'">
                  <li v-for="item in jsonDelEsp" :key="item.id">
                    <button @mouseover="position(item.value)" v-on:click="positionSelected(item.position, item.position, item.value)" :class="{'active-btn-gray': isClicked[item.position]}" class="btn btn-position">{{ item.positionEsp }}</button>
                  </li>
                </ul>
                <ul v-else>
                  <li v-for="item in jsonDel" :key="item.id">
                    <button @mouseover="position(item.value)" v-on:click="positionSelected(item.position, item.position, item.value)" :class="{'active-btn-gray': isClicked[item.position]}" class="btn btn-position">{{ item.position }}</button>
                  </li>
                </ul>
              </div>
            </div>
            <div class="map-area-container">
              <div class="map-area">
                <div class="cb-position" :class="{'d-block-hover': positionCB == true, 'd-block': isClicked['cb']}"></div>
                  <div class="lb-position" :class="{'d-block-hover': positionLB == true, 'd-block': isClicked['lb']}"></div>
                  <div class="rb-position" :class="{'d-block-hover': positionRB == true, 'd-block': isClicked['rb']}"></div>
                  <div class="lwb-position" :class="{'d-block-hover': positionLWB == true, 'd-block': isClicked['lwb']}"></div>
                  <div class="rwb-position" :class="{'d-block-hover': positionRWB == true, 'd-block': isClicked['rwb']}"></div>
                  <div class="dm-position" :class="{'d-block-hover': positionDM == true, 'd-block': isClicked['dm']}"></div>
                  <div class="lm-position" :class="{'d-block-hover': positionLM == true, 'd-block': isClicked['lm']}"></div>
                  <div class="cm-position" :class="{'d-block-hover': positionCM == true, 'd-block': isClicked['cm']}"></div>
                  <div class="rm-position" :class="{'d-block-hover': positionRM == true, 'd-block': isClicked['rm']}"></div>
                  <div class="am-position" :class="{'d-block-hover': positionAM == true, 'd-block': isClicked['am']}"></div>
                  <div class="s-position" :class="{'d-block-hover': positionS == true, 'd-block': isClicked['s']}"></div>
              </div>
            </div>
          </div>
          <div class="container-footer-drop">
            <p class="instruction">{{ $t('admin.select_characters')}}</p>

                <div class="content-options">
                  <div class="opt-radio content-radio-phy">
                    <label class="title-value" for="id1">{{ $t('playerFilter.physical')}}:</label>          
                    <div class="radio">
                      <label><input type="checkbox" v-model="skills.physical" value="Pace" name="optradio">Pace</label>
                    </div>
                    <div class="radio">
                      <label><input type="checkbox" v-model="skills.physical" value="Power" name="optradio">Power</label>
                    </div>
                    <div class="radio">
                      <label><input type="checkbox" v-model="skills.physical" value="Agility" name="optradio">Agility</label>
                    </div>
                    <div class="radio">
                      <label><input type="checkbox" v-model="skills.physical" value="Aerial play" name="optradio">Aerial play</label>
                    </div>
                    <div class="radio">
                      <label><input type="checkbox" v-model="skills.physical" value="Energy" name="optradio">Energy</label>
                    </div>
                  </div>
                  <div class="opt-radio content-radio-tac">
                    
                    <label class="title-value" for="id1">{{ $t('playerFilter.technical')}}:</label>
                    <div class="radio">
                      <label><input type="checkbox" v-model="skills.technical" value="Passing" name="optradio">Passing</label>
                    </div>
                    <div class="radio">
                      <label><input type="checkbox" v-model="skills.technical" value="Defending" name="optradio">Defending</label>
                    </div>
                    <div class="radio">
                      <label><input type="checkbox" v-model="skills.technical" value="Dribbling" name="optradio">Dribbling</label>
                    </div>
                    <div class="radio">
                      <label><input type="checkbox" v-model="skills.technical" value="Finishing" name="optradio">Finishing</label>
                    </div>
                    <div class="radio">
                      <label><input type="checkbox" v-model="skills.technical" value="Awareness" name="optradio">Awareness</label>
                    </div>
                  </div> 
                </div>
           
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 margin-between-section">
      <button v-on:click="savePlayer" type="btn" class="btn btn-action">{{ $t('admin.continue')}}</button>
    </div>
  </div>
</template>

<script>

import { bus } from "../main";
import Player from '@/parse/models/Players';
import * as tus from "tus-js-client"
import countries from "@/assets/data/countries.json";

export default {
  name: "player",
  components: {},
  data() {
    return {
      activeBtn: '',
      isClicked: [],

      idPlayer: this.$route.query.id,
      countries: countries,
      fileVideo: null,
      positionsPlayer: [],
      
      nombre: "",
      apellido: "",
      liga: "",
      equipo: "",
      fecha: "",
      altura: "",
      contacto: "",
      nacionalidad: "",
      pasaporte: "",
      pierna: "",
      skillGral: "",
      error: "",   
      cost: "",
      //-- End filters
      jsonDef: [
        { position: "cb", value: 1 },
        { position: "lb", value: 2 },
        { position: "rb", value: 3 },
        { position: "lwb", value: 4 },
        { position: "rwb", value: 5 },
      ],
      jsonMed: [
        { position: "dm", value: 6 },
        { position: "lm", value: 7 },
        { position: "cm", value: 8 },
        { position: "rm", value: 9 },
        { position: "am", value: 10 },
      ],
      jsonDel: [
        { position: "s", value: 11 }
      ],
      jsonDefEsp: [
        { position: "cb", positionEsp: "dfc", value: 1 },
        { position: "lb", positionEsp: "li", value: 2 },
        { position: "rb", positionEsp: "ld", value: 3 },
        { position: "lwb", positionEsp: "cri", value: 4 },
        { position: "rwb", positionEsp: "crd", value: 5 },
      ],
      jsonMedEsp: [
        { position: "dm", positionEsp: "md", value: 6 },
        { position: "lm", positionEsp: "exi", value: 7 },
        { position: "cm", positionEsp: "mc", value: 8 },
        { position: "rm", positionEsp: "exd", value: 9 },
        { position: "am", positionEsp: "mo", value: 10 },
      ],
      jsonDelEsp: [
        { position: "s", positionEsp: "del", value: 11 }
      ],
      costList: [
        { position: "0 - 100k", value: 1 },
        { position: "100k - 300k", value: 2 },
        { position: "300k - 500k", value: 3 },
        { position: "> 500k", value: 4 }
      ],

      positionGK: false,
      positionCB: false,
      positionLB: false,
      positionRB: false,
      positionLWB: false,
      positionRWB: false,
      positionDM: false,
      positionLM: false,
      positionCM: false,
      positionRM: false,
      positionAM: false,
      positionS: false,
      skills: {
        physical: [],
        technical: []
      },
      idiom: ''
    };
  },
  created(){
    if(localStorage.idiom){
      this.idiom = localStorage.idiom
    }
    /*bus.$on("change_array", (value) => {
      this.newPostion()
    });*/
  },
  beforeMount(){

    if (this.idPlayer){
      
      Player.loadInfoUnique(this.idPlayer)
      .then((user) => {
        this.nombre =  user.firstName
        this.apellido =  user.lastName
        this.liga =  user.league
        this.equipo =  user.team
        this.fecha =  user.birthday
        this.altura =  user.height
        this.contacto = user.email
        this.skillGral = user.willFit
      })
      .catch(error => console.error(error))
    }

    this.idiom = localStorage.idiom

    /*this.jsonDef = [
        { position: this.$t('playerFilter.cb'), value: 1 },
        { position: this.$t('playerFilter.lb'), value: 2 },
        { position: this.$t('playerFilter.rb'), value: 3 },
        { position: this.$t('playerFilter.lwb'), value: 4 },
        { position: this.$t('playerFilter.rwb'), value: 5 },
      ]
    this.jsonMed = [
        { position: this.$t('playerFilter.dm'), value: 6 },
        { position: this.$t('playerFilter.cm'), value: 7 },
        { position: this.$t('playerFilter.am'), value: 8 },
        { position: this.$t('playerFilter.lm'), value: 9 },
        { position: this.$t('playerFilter.rm'), value: 10 },
      ]
    this.jsonDel = [
        { position: this.$t('playerFilter.s'), value: 11 }
    ]*/
  },
  methods: {
    /*newPostion(){
      this.jsonDef = [
        { position: this.$t('playerFilter.cb'), value: 1 },
        { position: this.$t('playerFilter.lb'), value: 2 },
        { position: this.$t('playerFilter.rb'), value: 3 },
        { position: this.$t('playerFilter.lwb'), value: 4 },
        { position: this.$t('playerFilter.rwb'), value: 5 },
      ]
    this.jsonMed = [
        { position: this.$t('playerFilter.dm'), value: 6 },
        { position: this.$t('playerFilter.cm'), value: 7 },
        { position: this.$t('playerFilter.am'), value: 8 },
        { position: this.$t('playerFilter.lm'), value: 9 },
        { position: this.$t('playerFilter.rm'), value: 10 },
      ]
    this.jsonDel = [
        { position: this.$t('playerFilter.s'), value: 11 }
      ]
    },*/
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    position (item) {
//      this.positionGK = false,
      this.positionCB = false,
      this.positionLB = false,
      this.positionRB = false,
      this.positionLWB = false,
      this.positionRWB = false,
      this.positionDM = false,
      this.positionLM = false,
      this.positionCM = false,
      this.positionRM = false,
      this.positionAM = false,
      this.positionS = false
    

      switch (item) {
        
        case 1:
          //this.positionGK = true
          this.positionCB = true
          break;
        
        case 2:
          this.positionLB = true
          break;
        
        case 3:
          this.positionRB = true
          break;

        case 4:
          this.positionLWB = true

          break;

        case 5:
          this.positionRWB = true
          
          break;

        case 6:
          this.positionDM = true
          break;

        case 7:
          this.positionLM = true
          break;

        case 8:
          this.positionCM = true
          break;

        case 9:
          this.positionRM = true
          break;

        case 10:
          this.positionAM = true
          break;

        case 11:
          this.positionS = true
          break;
      
        default:
          break;
      }
    },
    positionSelected(position, index){

      this.$set(this.isClicked, index, !this.isClicked[index])
      
      const found = this.positionsPlayer.find(element => element == position);

      if(typeof found == "undefined"){
        this.positionsPlayer.push(position)
      } else{
        this.removeA(this.positionsPlayer, position);
      }
    },
    removeA(arr) {
      
      let what, a = arguments, L = a.length, ax;// eslint-disable-line
    
      while (L > 1 && arr.length) {
          what = a[--L];
          while ((ax= arr.indexOf(what)) !== -1) {
              arr.splice(ax, 1);
          }
      }
      return arr;
    },
    processFile(){
      this.fileVideo = event.target.files[0]
    },
    savePlayer(){

    /* const date = new Date(this.fecha)

      console.log("Date:" + date)

      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear()

      const finalDate = day+'/'+month+'/'+year
      
      console.log("Fecha:" + finalDate)
      return
      */

      if (this.nombre == ""){
        this.error = this.$t('notification.required')
        return
      }
      if (this.apellido == ""){
        this.error = this.$t('notification.required')
        return
      }
      if (this.liga == ""){
        this.error = this.$t('notification.required')
        return
      }
      if (this.fecha == ""){
        this.error = this.$t('notification.required')
        return
      }
      if (this.altura == ""){
        this.error = this.$t('notification.required')
        return
      }
      if (this.contacto == ""){
        this.error = this.$t('notification.required')
        return
      }
      if (this.nacionalidad == ""){
        this.error = this.$t('notification.required')
        return
      }
      if (this.pasaporte == ""){
        this.error = this.$t('notification.required')
        return
      }
      if (this.pierna == ""){
        this.error = this.$t('notification.required')
        return
      }
      if (this.cost == ""){
        this.error = this.$t('notification.required')
        return
      }
      if (this.skillGral == ""){
        this.error = this.$t('notification.required')
        return
      }
      if (this.positionsPlayer.length == 0){
        this.error = this.$t('notification.required')
        return
      }
      if (this.skills.length == 0){
        this.error = this.$t('notification.required')
        return
      }

    
      this.error = ""

      const date = new Date(this.fecha)

      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear()
      const finalDate = day+'/'+month+'/'+year
    

      const params = {
        id: this.idPlayer,
        name: this.nombre,
        lastname: this.apellido,
        team: this.equipo,
        email: this.contacto,
        skillGral: this.skillGral,
        league: this.liga,
        fecha: finalDate,
        height: this.altura,
        nacionalidad: this.nacionalidad,
        pasaporte: this.pasaporte,
        pierna: this.pierna,
        position: this.positionsPlayer,
        cost: this.cost,
        skills: this.skills,
        lang: localStorage.idiom

      }

      Player.savePlayer(params)
      .then((user) => this.$router.push('/edit-player?id=' + user.id))
      .catch(error => console.log(error))
      
      //this.notification = {}*/
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


/* Position */
.d-block-hover{
  display: block !important;
}

.d-block{
  display: block !important;
}


.active-btn-gray {
  background: #000;
  color: #fff;
}

.error {
  color: rgb(190, 0, 0);
  margin-top: 2%;
}


.radio input{
  margin-right: 5px;
}

.f-l{
  float: left; 
}

.f-r{
  float: right; 
}

.custom-select {
  background: #fff url("../assets/images/arrow_down.png") no-repeat right .75rem center/8px 10px;
  border: 1px solid #000;
  border-radius: 0;
  font-size: 13px;
}

.custom-select:focus{
  border-color: #000;
  box-shadow: none
}

.custom-select option {
    font-weight: 123px;
}

.content-options{
  position: relative;
  width: 100%;
  text-align: left;
  margin-top: 20px;
}

.opt-radio{
  display: inline-block;
  width: 50%;
}


.title-value{
  font-size: 12px;
  display: block;
}

.radio + .radio {
  margin: 15px 0 0 0;
}

.radio, .checkbox {
  display: block;
  margin: 15px 0 0 0;
}

.radio label, .checkbox label{
  font-size: 11px;
  font-weight: 600;
  text-decoration: underline;
}


.margin-top-item{
  margin-top: 10% !important;
}


/* Position */

.lb-position{
  position: absolute;
  width: 81.5px;
  height: 50px;
  left: 7px;
  background: rgba(139, 139, 139, 0.24);
  top: 0;
  opacity: 0.6;
  display: none;
}

.cb-position{
  position: absolute;
  width: 81.5px;
  height: 75px;
  left: 7px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
  display: none;
}

.rb-position{
  position: absolute;
  width: 81.5px;
  height: 51px;
  left: 7px;
  background: rgba(139, 139, 139, 0.24);
  bottom: 0;
  opacity: 0.6;
  display: none;
}

.lwb-position{
  position: absolute;
  width: 91.5px;
  height: 50px;
  left: 89px;
  background: rgba(139, 139, 139, 0.24);
  top: 0;
  opacity: 0.6;
  display: none;
}

.rwb-position{
  position: absolute;
  width: 91.5px;
  height: 50px;
  left: 89px;
  background: rgba(139, 139, 139, 0.24);
  bottom: 0;
  opacity: 0.6;
  display: none;
}

.dm-position{
  position: absolute;
  width: 45px;
  height: 76px;
  left: 89px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
  display: none;
}

.lm-position{
  position: absolute;
  width: 81px;
  height: 50px;
  left: 181px;
  background: rgba(139, 139, 139, 0.24);
  top: 0;
  opacity: 0.6;
  display: none;
}

.cm-position{
  position: absolute;
  width: 44.5px;
  height: 76px;
  left: 136px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
  display: none;
}

.rm-position{
  position: absolute;
  width: 81px;
  height: 50px;
  left: 181px;
  background: rgba(139, 139, 139, 0.24);
  bottom: 0;
  opacity: 0.6;
  display: none;
}

.am-position{
  position: absolute;
  width: 45px;
  height: 76px;
  left: 181px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
  display: none;
}

.s-position{
  position: absolute;
  width: 35px;
  height: 76px;
  left: 227px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
  display: none;
}

.gk-map{
  position: absolute;
  width: 31px;
  height: 50px;
  left: 0px;
  background: green;
  top: 102px;
  opacity: 0.6;
}

.lat-i-map{
  position: absolute;
  width: 390px;
  height: 50px;
  left: 0;
  background: blue;
  top: 0;
  opacity: 0.6;
}

.lat-d-map{
  position: absolute;
  width: 390px;
  height: 50px;
  left: 0;
  background: red;
  bottom: 0;
  opacity: 0.6;
}

.def-map{
  position: absolute;
  width: 129px;
  height: 253px;
  left: 0;
  background: black;
  opacity: 0.6;
}

.med-map{
  position: absolute;
  width: 129px;
  height: 253px;
  margin-left: 130px;
  background: purple;
  opacity: 0.6;
}

.del-map{
  position: absolute;
  width: 129px;
  height: 253px;
  right: 0;
  background: orange;
  opacity: 0.6;
}


.map-area-container{
  background-color: #fff;
  width: 270px;
  height: 176px;
  position: relative;
  z-index: 1;
  margin-top: 10px;
  margin-left: 10px;
  display: inline-block;
}

.map-area{
  background: url(/img/camp.10dfa781.png)no-repeat;
  width: 270px;
  height: 176px;
  position: relative;
  background-size: 270px;
}

/* Position */

.btn {
  font-size: 12px;
}

.btn-action {
  display: inline-block;
  background: #fff;
  color: #000;
  border: 1px solid #000;
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
  border-radius: 0;
}

ul {
  text-decoration: none;
  list-style: none;
  margin: 0;
  padding: 0;
}

ul li {
  display: inline;
  margin-right: 10%;
}

.btn-position {
  font-size: 10px;
  border-bottom: 1px solid #000;
  width: 25px;
  padding: 0;
  margin-right: 5px;
  text-transform: uppercase;
  font-family: "plain medium", arial;
}

.margin-zero {
  margin: 0;
}
.padding-zero {
  padding: 0;
}

.c-header {
  width: 100%;
}

.info {
  text-align: left;
  width: 100%;
}

.info h1 {
  font-size: 20px;
  font-family: "plain regular", arial;
  display: inline-block;
  font-weight: bold;
}

.container-age {
  display: inline-block;
  margin: 7px;
  width: 100%;
}

.info h1 img {
  width: 20px;
  margin-right: 10px;
  margin-top: -8px;
}

.info p {
  font-size: 18px;
}

.container-info {
  font-family: "plain regular", arial;
}

.container-info h1 {
  font-family: "plain regular", arial;
  float: left;
}

.container-info a {
  color: #000;
  font-family: "plain regular", arial;
  float: right;
  margin-right: 5px;
}

.container-info a img {
  width: 20px;
}

.not-margin {
  margin: 0;
}

.not-padding {
  padding: 0;
}

.group {
  margin-top: 6.5%;
}

.info-form-contact {
  text-align: left;
  font-size: 13px;
}

.info-form-contact label {
  margin-bottom: 0;
  font-size: 13px;
}

.input-form {
  border: 0;
  border-bottom: 1px solid #000;
  width: 80%;
  padding-bottom: 10px;
}

.con-i input {
  border: 0;
  border-bottom: 1px solid #000;
  width: 120px;
  font-size: 12px;
  margin-left: 5%;
}

.send-b {
  border: 1px solid #000;
  border-radius: 0;
  margin-left: 0px;
  font-size: 12px;
  padding: 5px 30px;
  margin-bottom: 9px;
}

.container-drop {
  text-align: center;
}


.dropdown {
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
}

.dropdown-menu {
  border: 1px solid #000;
  border-radius: 0;
  margin: 0.125rem -1px 0;
}

.dropdown-toggle::after {
  margin-left: 5em;
}

.dropdown-btn {
  font-size: 13px;
}

.dropdown-item {
  font-size: 13px;
}

.instruction {
  color: #000;
  font-size: 11px !important;
  font-family: "plain regular", arial;
}

.instruction-position {
  color: rgb(138, 138, 138);
  font-size: 9px !important;
}

.camp-position {
  position: relative;
  display: block;
  margin-top: 7%;
}

.content-button-filter{
  display: inline-block;
  float: left;
  width: 50%;
}


.container-footer-drop {
  position: relative;
  margin: 7px;
}

.container-footer-drop img {
  width: 50%;
  margin-bottom: 5px;
}

.instruction-mapa {
  color: rgb(124, 124, 124);
  font-size: 9px !important;
  margin-left: 10px;
}

#uplimage {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

label[for="uplimage"] {
  font-weight: 600;
  color: #000;
  border: 1px solid #000;
  background-color: #fff;
  display: inline-block;
  transition: all .5s;
  cursor: pointer;
  padding: 5px 40px !important;
  width: fit-content;
  text-align: center;
}

label[for="uplimage"] img{
  width: 18px;
  margin-right: 10px;
}


/* Mobile first queries */

/* Larger than Desktop HD */
@media (max-width: 1200px) {}

/* Larger than desktop */
@media (max-width: 992px) {
  .custom-select {
    padding: .1rem .1rem .1rem .1rem;
  }

  .dropdown {
    margin-top: 5px;
    width: 140px;
  }

  .f-l{
    float: initial; 
  }

  .f-r{
    float: initial; 
  }


  .content-button-filter{
    width: 100%;
  }


}

/* Larger than tablet */
@media (max-width: 768px) {
  .content-button-filter{
    width: 100%;
  }

}

/* Larger than phablet */
@media (max-width: 550px) {
}

/* Larger than mobile */
@media (max-width: 400px) {}

</style>
